import { SAVE_STATION_LIST } from "./types"


export const saveStationList =  (payload) => {
    return {
      type: SAVE_STATION_LIST,
      payload
    }
  }